import users from './users.js'
import accessGroup from './accessGroup.js'
import characters from './characters.js'

export default {
  menu: 'Users',

  users,
  accessGroup,
  characters
}
